import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SelectionChangedEvent,
  ColGroupDef,
  ColDef
} from '@ag-grid-enterprise/all-modules';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import { SnmpDestination } from 'data/snmp/snmp.types';
import SnmpDestGridActionMenu from './SnmpDestGridActionMenu';

interface Props {
  data: SnmpDestination[];
  hasPrivilegeToView: boolean;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  noResults: boolean;
  beforeLogout: boolean;
  lastUpdatedAt: Date | undefined;
  columnDefs: (ColGroupDef | ColDef)[];
  selectedSnmpDest: SnmpDestination | null;
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onSelectionChanged: (event: SelectionChangedEvent) => void;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const SnmpDestListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedSnmpDest,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onView,
  onEdit,
  onDelete
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer
  };
  const { t } = useTranslation();

  return (
    <div
      className="grid-container"
      style={{ height: 'inherit' }}
      data-testid="SnmpDestList"
    >
      <CommonGrid
        createNewText={t('snmpDest.grid.newSnmpDest')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        components={components}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        onActionMenuItemClick={onView}
        lastUpdatedAt={lastUpdatedAt}
      >
        <SnmpDestGridActionMenu
          selectedItem={selectedSnmpDest}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </CommonGrid>
    </div>
  );
};

export default SnmpDestListGrid;
